import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('withOptions');

const withOptions = (fn) => {
  if (isNotFn(fn)) L.debug('withOptions()', 'Invalid function fn:', fn);

  // using this indirect approach as to let the JS engine give our desired name to the new function
  const temporary = {};
  const functionName = `withOptions(${fromAnyToTrimmed(fn.name) || 'Unknown'})`;

  temporary[functionName] = (options, ...extra) => fn(asObject(options), ...extra);
  Object.defineProperty(temporary[functionName], 'name', { value: functionName });

  return temporary[functionName];
};

// noinspection JSUnusedGlobalSymbols
export default withOptions;
